import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Services
export const getServices = () => api.get('/services');
export const getService = (slug) => api.get(`/services/${slug}`);

// Cities
export const getCities = () => api.get('/cities');
export const getCity = (slug) => api.get(`/cities/${slug}`);

// Leads
export const createLead = (data) => api.post('/leads', data);

// Contact
export const submitContact = (data) => api.post('/contact', data);

// Quotes
export const createQuote = (data) => api.post('/quotes', data);
export const uploadQuoteFiles = (quoteId, files) => {
  const formData = new FormData();
  files.forEach(file => formData.append('files', file));
  return api.post(`/quotes/${quoteId}/files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const getQuote = (quoteId) => api.get(`/quotes/${quoteId}`);

// Chat
export const sendChatMessage = (data) => api.post('/chat', data);

// Payments
export const createCheckout = (data) => api.post('/payments/checkout', data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`);

// Testimonials
export const getTestimonials = () => api.get('/testimonials');

export default api;
